
import { Box, Typography, Divider, Button } from "@mui/material";

function InfluencerInfo(props) {
  const { name, activityPlace, instagram, telegram, facebook, twitter, youtube, otherPlace, situation, description } = props;

  return (
    <Box sx={{ textAlign: "justify" }} component="main">
      <Divider />
      <Typography>
        نام : {name}
      </Typography>
      <Divider />
      <Typography>
        محل فعالیت	: {activityPlace}
      </Typography>
      <Divider />
      <Typography>
        آدرس پیج اینستاگرام : {instagram}
      </Typography>
      <Divider />
      <Typography>
        آدرس پیج تلگرام: {telegram}
      </Typography>
      <Divider />
      <Typography>
        آدرس صفحه فیس بوک : {facebook}
      </Typography>
      <Divider />
      <Typography>
        آدرس صفحه توییتر : {twitter}
      </Typography>
      <Divider />
      <Typography>
        آدرس صفحه یوتیوب : {youtube}
      </Typography>
      <Divider />
      <Typography>
        دیگر شبکه های اجتماعی : {otherPlace}
      </Typography>
      <Divider />
      <Typography>
        دیگر توضیحات : {description}
      </Typography>
      <Divider />
      <Typography sx={{ fontWeight: "bolder" }}>
        وضعیت ثبت نام : {situation}
      </Typography>
    </Box>
  );
}

export default InfluencerInfo;
